import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'audit_iso_26000'

export const dataPointDefinition = {
  retracedId: 'audit_iso_26000',
  name: 'ISO 26000',
  meta: {
    asset: 'AUDITS',
  },
  fieldTypeId: 'ASSET',
  type: 'GLOBAL',
  options: [],
  schema: {
    body: {
      type: 'object',
      required: ['id', 'auditTypeId', 'uploaderCompanyId', 'name'],
      additionalProperties: false,
      properties: {
        id: {
          type: 'string',
          minLength: 1,
          maxLength: 36,
        },
        companyId: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        companyName: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        uploaderCompanyId: {
          type: 'string',
          minLength: 1,
          maxLength: 64,
        },
        uploaderCompanyName: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        name: {
          type: 'string',
          minLength: 1,
          maxLength: 255,
        },
        nextPlannedAuditDate: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        referenceNumber: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        facilityScore: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        auditedBy: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        auditReportFileId: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        correctiveActionPlanFileId: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        type: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        auditTypeId: {
          type: 'string',
          minLength: 1,
          maxLength: 255,
        },
        isPublic: {
          oneOf: [
            {
              type: 'boolean',
            },
            {
              type: 'number',
            },
          ],
        },
        auditTypeName: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        auditDate: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        dataStatus: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        aiActions: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        auditReportFileUrl: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        auditReportFileOriginalUrl: {
          type: ['string', 'null'],
          minLength: 1,
        },
        auditReportFileType: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        auditReportFileContentType: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        auditReportFileBucketName: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        extractedData: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        correctiveActionPlanFileUrl: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        correctiveActionPlanFileOriginalUrl: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        correctiveActionPlanFileFileType: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        correctiveActionPlanFileContentType: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        correctiveActionPlanFileBucketName: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        permissions: {
          oneOf: [
            {
              type: 'array',
            },
            {
              type: 'null',
            },
          ],
        },
        privacyStatus: {
          oneOf: [
            {
              type: 'object',
            },
            {
              type: 'null',
            },
          ],
        },
        profileType: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        updatedAt: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        updatedByImpersonateId: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        updatedByImpersonateName: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        updatedByUserId: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        updatedByUserName: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        updatedByCompanyId: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        updatedByCompanyName: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        updatedByApiKeyId: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        updatedByApiKeyLabel: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        createdAt: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        createdByImpersonateId: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        createdByUserId: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        createdByCompanyId: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        createdByApiKeyId: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        createdByApiKeyLabel: {
          oneOf: [
            {
              type: 'string',
            },
            {
              type: 'null',
            },
          ],
        },
        findings: {
          oneOf: [
            {
              type: 'array',
              items: {
                type: 'object',
                required: ['auditId', 'title'],
                additionalProperties: true,
                properties: {
                  id: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 36,
                  },
                  auditId: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 36,
                  },
                  companyId: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 36,
                  },
                  title: {
                    type: 'string',
                    minLength: 1,
                  },
                  impactAreaId: {
                    oneOf: [
                      {
                        type: 'string',
                        minLength: 1,
                      },
                      {
                        type: 'null',
                      },
                    ],
                  },
                  description: {
                    oneOf: [
                      {
                        type: 'string',
                        minLength: 1,
                      },
                      {
                        type: 'null',
                      },
                    ],
                  },
                  urgency: {
                    oneOf: [
                      {
                        type: 'string',
                        minLength: 1,
                      },
                      {
                        type: 'null',
                      },
                    ],
                  },
                  source: {
                    oneOf: [
                      {
                        type: 'string',
                        minLength: 1,
                      },
                      {
                        type: 'null',
                      },
                    ],
                  },
                  isRemoved: {
                    oneOf: [
                      {
                        type: 'number',
                      },
                      {
                        type: 'null',
                      },
                    ],
                  },
                  suggestedActions: {
                    oneOf: [
                      {
                        type: 'array',
                        items: {
                          type: 'string',
                        },
                      },
                      {
                        type: 'null',
                      },
                    ],
                  },
                },
              },
            },
            {
              type: 'null',
            },
          ],
        },
      },
    },
  },
  externalIds: [],
  sortingId: 26180,
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
